import React, { useCallback } from "react";
import { List, NoTasks } from "./List";
import { useGameTasks } from "@seabrookstudios/pitch2table";
import { TaskFilters } from "@seabrookstudios/pitch2table-core";
import { useGameIdFromRoute } from "../WithGameIdFromRoute";
import { useMakeListAndDetail } from "../../core/useMakeLayout";
import { AddTaskDialog } from "./AddTaskDialog";
import { Path } from "../../Path";
import Box from "@mui/material/Box";
import { ListView } from "../../core/ListView";
import { FilterList } from "../../core/FilterList";

export const ListAndDetail = () => {
  const gameId = useGameIdFromRoute();
  const Action = () => <AddTaskDialog gameId={gameId} />;

  /**
   * Custom list builder that wraps the drag-and-drop List component
   * while maintaining all ListView features (back, refresh, add, filters)
   */
  const useMakeList = (queryResult, filters) => {
    const Filters = useCallback(
      () => (
        <FilterList
          filters={filters.visibleFilters}
          filter={filters.filter}
          onFilterClicked={filters.onFilterClicked}
        />
      ),
      [filters]
    );

    const BuiltList = () => (
      <ListView
        back={Path.game(gameId).link()}
        title="Tasks"
        Filters={Filters}
        Action={Action}
        EmptyList={NoTasks}
        shown={filters.filtered.length}
        refetch={queryResult.refetch}
        isLoading={queryResult.isLoading}
        isRefetching={queryResult.isRefetching}
        isError={queryResult.isError}
      >
        <List tasks={filters.filtered} />
      </ListView>
    );

    return BuiltList;
  };

  const useWrappedQuery = () => useGameTasks(gameId);

  const ListAndDetailComponent = useMakeListAndDetail(useWrappedQuery, TaskFilters, "tasks", useMakeList, () => (
    <Box />
  ));

  return <ListAndDetailComponent />;
};
